<template>
  <!-- 下单填写资料弹框 -->
  <div>
    <el-dialog
      width="860px"
      center
      :visible.sync="visible"
      :append-to-body="true"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
    >
      <div class="agreement-wrap">
        <vue-office-docx
          src="https://pic.zlfeco.cn/file/reviews?bucket=zlf-yun&fileName=/隐私政策.docx"
          style="width: 810px; height: auto;"
        />
        <el-button type="primary" @click="handleClose">我已知晓</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ls from '@/utils/localStorage'
//引入VueOfficeDocx组件
import VueOfficeDocx from '@vue-office/docx'
//引入相关样式
import '@vue-office/docx/lib/index.css'

export default {
  name: 'DialogAgreement',
  components: {
    VueOfficeDocx,
  },
  data() {
    return {
      visible: false,
      disabled: false,
    }
  },
  mounted() {},
  methods: {
    handleShow() {
      this.visible = true
    },
    handleClose() {
      this.visible = false
      ls.set('isAgreement', true)
    },
  },
}
</script>
<style lang="scss">
.agreement-wrap {
  text-align: center;
}

.vue-office-docx {
  .docx-wrapper {
    padding: 0;
    background: #fff;
  }

  .docx-wrapper > section.docx {
    box-shadow: none;
  }
}
</style>
